export default "__VITE_ASSET__UU1q4N5J__"